import { MAX_FEEDBACK_COMMENT_LENGTH, isFeedbackRating, type FeedbackRating } from '@hotel-voice/shared';

export interface FeedbackDraft {
  rating: number | null;
  comment: string;
}

export type FeedbackValidation =
  | { ok: true; rating: FeedbackRating; comment: string | undefined }
  | { ok: false; error: string };

/** The rating is the one required field; the comment is optional and capped. */
export function validateFeedback(draft: FeedbackDraft): FeedbackValidation {
  if (!isFeedbackRating(draft.rating)) {
    return { ok: false, error: 'Please choose a star rating.' };
  }
  const comment = draft.comment.trim();
  if (comment.length > MAX_FEEDBACK_COMMENT_LENGTH) {
    return {
      ok: false,
      error: `Please keep your comment under ${MAX_FEEDBACK_COMMENT_LENGTH} characters.`,
    };
  }
  return { ok: true, rating: draft.rating, comment: comment.length ? comment : undefined };
}
